<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.2516 10.5">
		<path d="M6.5 10.5A5.25 5.25 0 1 1 10 1.3374a.74969307.74969307 0 1 1-.9962 1.1206L9 2.4546a3.74976 3.74976 0 1 0 0 5.59131.74969.74969 0 0 1 1 1.11719A5.24087 5.24087 0 0 1 6.5 10.5Z"/>
		<path d="M5.25 5.25H.75a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 0 1.5Zm0 2H.75a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 0 1.5Z"/>
	</svg>
</template>
